
  import EventBus from '@/events/EventBus';
  import {createObjectFromQueryString} from '@/helper/QueryHelper';
  import clearableTabIndex from '@/mixins/clearableTabIndex';
  import ModelItems from '@/mixins/ModelItems';
  import {debounce} from 'lodash/function';

  export default {
    name: 'OrganizationListingFilter',
    mixins: [clearableTabIndex, ModelItems],
    props: {
      filterParams: {
        type: String,
        required: false,
        default: undefined,
      },
      useFacets: {
        type: Boolean,
        required: false,
        default: false,
      },
      facets: {
        type: Object,
        required: false,
        default: undefined,
      },
      newSearchArray: {
        type: Array,
        required: false,
        default: undefined,
      },
    },
    data() {
      return {
        searchCarousel: 0,
        cycle: false,
        searches: [],
        descriptionLimit: 60,
        isCleared: false,
        what: null,
        activities: [],
        industries: [],
        expandActivities: false,
        expandIndustries: false,
        activityItems: [],
        industryItems: [],
        organizationsWithOpenJobs: null,
        items: [
          {value: '1', text: 'filter.organizations_with_open_jobs'},
          {value: '0', text: 'filter.organizations_without_open_jobs'},
        ],
      };
    },
    fetch() {
      if (this.useFacets) this.setFacetsFromProp();
    },
    computed: {
      displayActivityItems() {
        return this.expandActivities
          ? this.activityItems
          : this.activityItems.slice(0, 5);
      },
      displayIndustryItems() {
        return this.expandIndustries
          ? this.industryItems
          : this.industryItems.slice(0, 5);
      },
    },
    watch: {
      filterParams: function () {
        this.setFilterValues();
        this.searchCarousel = 0;
      },
      newSearchArray: function (val) {
        this.searches = val;
      },
      facets: {
        deep: true,
        handler() {
          if (this.useFacets) this.setFacetsFromProp();
        },
      },
    },
    created() {
      if (process.client) {
        this.setUpSearches();
      }
      this.isCleared = false;
      this.activityItems.sort(function (a, b) {
        return b.counter - a.counter;
      });

      this.industryItems.sort(function (a, b) {
        return b.counter - a.counter;
      });

      this.setFilterValues();
    },
    methods: {
      setFacetsFromProp() {
        this.activityItems = [];
        this.industryItems = [];

        this.$nextTick(() => {
          if (
            !this.facets ||
            !this.facets['activities'] ||
            !this.facets['industries']
          )
            return;

          const activityChoices = [];
          this.facets['activities'].forEach((item) => {
            this.activityItems.push({
              value: item.value,
              text: this.$t(item.value),
              counter: item.count,
            });
            activityChoices.push(item.value);
          });
          // Add selected items with 0 counter
          this.activities.forEach((activity) => {
            if (!activityChoices.includes(activity))
              this.activityItems.push({
                value: activity,
                text: this.$t(activity),
                counter: 0,
              });
          });

          const industryChoices = [];
          this.facets['industries'].forEach((item) => {
            this.industryItems.push({
              value: item.value,
              text: this.$t(item.value),
              counter: item.count,
            });
            industryChoices.push(item.value);
          });
          // Add selected items with 0 counter
          this.industries.forEach((industry) => {
            if (!industryChoices.includes(industry))
              this.industryItems.push({
                value: industry,
                text: this.$t(industry),
                counter: 0,
              });
          });
        });
      },
      async setUpSearches() {
        const allSavedSearches = await this.$localforage.getItem(
          'SavedSearches'
        );
        if (allSavedSearches && allSavedSearches.length > 0) {
          allSavedSearches.map((item) => {
            if (item.page === this.$route.path) {
              this.searches.push(item);
            }
          });
        }
      },
      repeatSearch(url) {
        this.searchCarousel = 0;
        this.whereSearch = null;
        this.$router.push(url);
      },
      clearInput() {
        this.isCleared = true;
      },
      setFilterValues() {
        this.resetFilterValues();
        const filterValues = createObjectFromQueryString(this.filterParams);
        if (Object.keys(filterValues).length === 0) {
          this.clearInput();
        }

        if (filterValues.search) {
          this.what = filterValues.search;
        }
        if (filterValues['activity[]']) {
          this.activities = this.industries.concat(filterValues['activity[]']);
        }
        if (filterValues['industry[]']) {
          this.industries = this.industries.concat(filterValues['industry[]']);
        }
        if (filterValues.openJobs) {
          this.organizationsWithOpenJobs = filterValues.openJobs;
        }
      },
      applyFilterWithThrottle: debounce(function () {
        this.applyFilter(true);
      }, 2000),
      applyFilter(button = false) {
        this.isCleared = false;
        const params = new URLSearchParams();
        if (this.what) {
          params.append('search', this.what);
        }
        if (this.activities) {
          this.activities.forEach((activity) => {
            params.append('activity[]', activity);
          });
        }
        if (this.industries) {
          this.industries.forEach((industry) => {
            params.append('industry[]', industry);
          });
        }
        if (this.organizationsWithOpenJobs != null) {
          params.append('openJobs', this.organizationsWithOpenJobs);
        }
        const event = button ? 'listing-filter-button' : 'listing-filter';
        EventBus.$emit(event, params);
        this.$emit(event, params);
      },
      resetFilter() {
        this.resetFilterValues();
        this.emitResetFilterEvent();
      },
      resetFilterValues() {
        this.what = null;
        this.activities = [];
        this.industries = [];
        this.organizationsWithOpenJobs = null;
      },
      emitResetFilterEvent() {
        EventBus.$emit('listing-filter-reset');
        this.$emit('listing-filter-reset');
      },
    },
  };
